(function () {
    'use strict';

    angular.module('app').factory('localStorageService', LocalStorageServiceFactory);

    LocalStorageServiceFactory.$inject = ['$locale',];
    function LocalStorageServiceFactory($locale) {

        return {
            getByKey,
            setByKey,
            isOutDated
        };

        function getByKey(key) {
            if (!key || !localStorage[key])
                return null;
            return JSON.parse(localStorage[key]);
        }

        function setByKey(key, value) {
            if (!key)
                return;
            localStorage[key] = JSON.stringify(value);
        }

        function isOutDated(timestampKey, languageKey) {
            // If the languageKey is present first check this
            if (languageKey) {
                const currentLanguage = getByKey(languageKey);
                if (!currentLanguage || $locale.id !== currentLanguage.toLowerCase())
                    return true;
            }

            const loadedOn = getByKey(timestampKey);
            if (!loadedOn)
                return true;

            const timestamp = new Date(loadedOn);
            // Check whether saved date is before today
            return new Date((new Date()).toDateString()) > timestamp;
        }
    }
})();
